import React, { useEffect, useState } from 'react'
import { ModalBody, Label, Row, Col } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import Resx from '@/components/Resx'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { DatePicker } from '@/components/DatePicker'
import CheckBox from '@/components/CheckBox'
import getEnumTranslation from '@/enums/enums'
import { applicationTypes } from '@/enums/ApplicationTypes'
import { RichTextEditor } from '@/components/richTextEditor'

const AddNewAnnouncementDialog = (props) => {
  const [state, setState] = useState({ ...props.announcement })

  useEffect(() => {
    setState({ ...props.announcement })
  }, [props.announcement])

  const saveChanges = () => {
    props.onAction({
      ...state,
      isActive: false,
      isOnlyForSelectedInstitutions: false
    })
  }

  const { localize } = props
  const hasAnyTarget = state.isForInternalApp || state.isForExternalApp

  return (
    <ValidationBoundary>
      <BasicHeader title='Common.Add' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Row>
            <Label sm={4}><Resx name='Common.ValidFrom' />: </Label>
            <Col sm={8}>
              <Validator name='validFrom' value={state.validFrom} required>
                <DatePicker
                  value={state.validFrom}
                  onChange={(value) => setState(prev => ({ ...prev, validFrom: value }))} />
              </Validator>
            </Col>
          </Row>
          <Row>
            <Label sm={4}><Resx name='Common.ValidTo' />: </Label>
            <Col sm={8}>
              <Validator name='validTo' value={state.validTo} required>
                <DatePicker
                  value={state.validTo}
                  onChange={(value) => setState(prev => ({ ...prev, validTo: value }))} />
              </Validator>
            </Col>
          </Row>
          <Row>
            <Label sm={4}><Resx name='Common.Text' />: </Label>
            <Col sm={8}>
              <RichTextEditor
                value={state.text}
                onChange={text => setState(prev => ({ ...prev, text }))} />
            </Col>
          </Row>
          <Row>
            <Label sm={4}><Resx name='Common.LatinText' />: </Label>
            <Col sm={8}>
              <RichTextEditor
                value={state.latinText}
                onChange={latinText => setState(prev => ({ ...prev, latinText }))} />
            </Col>
          </Row>
          <Row>
            <Label sm={4}><Resx name='Common.ApplicationTypes' />: </Label>
            <Col sm={8}>
              <CheckBox
                id='application_type_internal'
                label={getEnumTranslation({ localize, enumName: applicationTypes.enumName, value: applicationTypes.enum.InternalApp })}
                checked={state.isForInternalApp}
                onChange={value => setState(prev => ({ ...prev, isForInternalApp: value }))}
              />
              <CheckBox
                id='application_type_external'
                label={getEnumTranslation({ localize, enumName: applicationTypes.enumName, value: applicationTypes.enum.ReportApp })}
                checked={state.isForExternalApp}
                onChange={value => setState(prev => ({ ...prev, isForExternalApp: value }))}
              />
            </Col>
          </Row>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={saveChanges} disabled={!isValid || !hasAnyTarget} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: AddNewAnnouncementDialog,
  modalProps: { size: 'lg' }
}



// WEBPACK FOOTER //
// ./src/dialogs/addNewAnnouncement.js